/**
 * Parse a pasted iconik web-app link down to the object id it points at — the one "how do I tell
 * the portal which iconik object I mean" pattern this app already uses (Phase A's "paste the
 * iconik link of the first game-action clip", `AnchorReviewPanel.tsx`), extended here to the two
 * other object kinds `NewRunModal.tsx` needs (Monday 12921140208). No browse/search UI exists
 * anywhere in this app to pick a collection/saved-search/asset by clicking through iconik's own
 * tree — paste-a-link is the established, minimal-effort way to name one.
 *
 * URL shapes mirror the backend's OWN link builders byte-for-byte
 * (`apps/customer-api/src/services/iconikDeepLinks.ts`): `/collection/<id>`, `/savedsearch/<id>`.
 * Asset links (`/asset/<id>/...`) were already covered by the pre-existing
 * `parseIconikAssetUrl`, moved here unchanged so all three live in one place instead of two.
 *
 * No host check, deliberately — a real saved search's own path was wrong here for a while
 * (Monday 12941628059: `/search/<id>` isn't a real iconik route, `/savedsearch/<id>` is — the
 * "unverified" hedge this doc comment used to carry on that path was earned) even though the
 * HOST was never the issue: a customer confirmed both `app.iconik.io` and `app.aws.iconik.io`
 * resolve to the same iconik instance, so matching the path anywhere in the string already
 * handles both without branching on which one was pasted.
 */

/** `null` for anything that doesn't match — the id isn't strictly validated as a UUID; the
 *  backend re-validates whatever comes through against iconik itself when it resolves a title. */
export function parseIconikAssetUrl(raw: string): string | null {
  const match = raw.trim().match(/\/asset\/([a-zA-Z0-9-]+)/);
  return match ? match[1] : null;
}

export function parseIconikCollectionUrl(raw: string): string | null {
  const match = raw.trim().match(/\/collection\/([a-zA-Z0-9-]+)/);
  return match ? match[1] : null;
}

export function parseIconikSavedSearchUrl(raw: string): string | null {
  const match = raw.trim().match(/\/savedsearch\/([a-zA-Z0-9-]+)/);
  return match ? match[1] : null;
}
